import toast from "react-hot-toast";

const originalFetch = window.fetch;

function dispatchNetworkError(error) {
    const event = new CustomEvent("network-error", {
        detail: {
            message: error.message || "Unknown network error",
            name: error.name,
            status: error.status,
            url: error.url,
        },
    });
    window.dispatchEvent(event);
}

window.fetch = async function (resource, config) {
    try {
        const response = await originalFetch(resource, config);
        if (response?.url === "https://synth-staging.tradeally.io/copilotkit" && !response.ok) {
            const error = new Error(`HTTP error! Status: ${response.status}`);

            toast.error(error?.message || "An error occured, Please try again later");
            throw error;
        }
        return response;
    } catch (err) {
        if (resource && resource === "https://synth-staging.tradeally.io/copilotkit") {
            // dispatchNetworkError(err);
         
            toast.error("Network error occured, Please try again later");
            throw err;
        }
    }
};

// window.addEventListener("network-error", (e) => {
//
// });
